<template>
  <div class="stockCheck column-me">
    <div class="top-div row-me row-center flex-end1">
      <div class="btn-border width80 btn-height40" @click="clickCancel" v-if="status===0">取消</div>
      <el-button type="warning" class="width80 margin-left10" @click="clickPause" v-if="status===0"
                 :disabled="isDisabledPause">
        暂存
      </el-button>
      <el-button type="primary" class="width80 margin-left10" @click="clickComplete" v-if="status===0"
                 :disabled="isDisabledDone">
        完成
      </el-button>
      <el-button type="success" class="width80 margin-left10" @click="clickPing" :disabled="isDisabledPing">
        平库
      </el-button>
      <div class="btn-blank width80 btn-height40 margin-left10" @click="clickBack">返回</div>
    </div>
    <div class="card-div column-me flex1 overflow-auto">
      <div class="row-me row-center flex-wrap">
        <div class="width300">
          <el-select v-model="selectHouse" placeholder="请选择库房" style="width: 100%;" filterable clearable
                     @change="houseChange">
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width300 margin-left20">
          <el-input placeholder="备注(选填)" style="width: 100%;" clearable v-model="remark" maxlength="200">
          </el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickPan">
          <el-icon>
            <search/>
          </el-icon>
          盘点
        </div>
        <div class="flex1"></div>
        <div class="btn-green width140 btn-height40 margin-left20" @click="clickImport" v-if="this.id!==''">导入
        </div>
        <div class="btn-orange width140 btn-height40 margin-left20" @click="clickExport" v-if="this.id!==''">导出
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="flex1">
          <el-input v-model="searchName" style="width: 100%;" clearable placeholder="搜索药品名" @input="drugInput"
                    @focus="drugInput">
            <template #prefix>
              <el-icon class="el-input__icon">
                <search/>
              </el-icon>
            </template>
          </el-input>
        </div>
      </div>
      <div class="column-me flex1 margin-top20 overflow-auto">
        <div class="flex1 overflow-auto">
          <el-table :data="tableDataNew.slice((pageNo-1)*10,pageNo*10)" border
                    header-cell-class-name="table-header-style" cell-class-name="table-cell-style">
            <el-table-column prop="drugName" label="药品名称" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="spec" label="规格" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="unitName" label="单位" align="center" width="80"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="batchNo" label="批号" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="剂型" align="center" width="100" show-overflow-tooltip>
              <template v-slot="scope">
                <div>{{ scope.row.drugType === 0 ? '常规剂型' : scope.row.drugType === 1 ? '颗粒剂型' : '' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="validityTime" label="有效期" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="produceTime" label="生产日期" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="costPrice" label="入库价" align="center" width="80"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="实际数量" align="center" width="120" show-overflow-tooltip>
              <template #default="scope">
                <div class="row-me center-all">
                  <div class="width100" :title="scope.row.actualNums">
                    <el-input placeholder="请输入" style="width: 100%;" type="number"
                              v-model="scope.row.actualNums" @input="numberInput(scope.row)"
                              :disabled="status===1">
                    </el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="时间节点" align="center" width="250" show-overflow-tooltip>
              <template #default="scope">
                <div class="row-me center-all">
                  <div class="width100Per">
                    <el-date-picker type="datetime" placeholder="请选择" format="YYYY-MM-DD HH:mm"
                                    value-format="YYYY-MM-DD HH:mm" style="width: 100%;"
                                    v-model="scope.row.finishTime" :disabled="status!==0">
                    </el-date-picker>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="subNums" label="盈亏数量" align="center" width="100"
                             show-overflow-tooltip>
              <template #default='scope'>
                <div v-if="scope.row.subNums!==null&&scope.row.subNums!==''" :title="scope.row.subNums">
									<span class="orange-div"
                        v-if="Number(scope.row.actualNums)<Number(scope.row.bookNums)">亏</span>
                  <span class="blue-div"
                        v-if="Number(scope.row.actualNums)>Number(scope.row.bookNums)">盈</span>
                  <span class="green-div"
                        v-if="Number(scope.row.actualNums)===Number(scope.row.bookNums)">平</span>
                  {{ scope.row.subNums }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="bookNums" label="账面数量" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="producerName" label="生产商" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="supplierName" label="供应商" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="productAddress" label="产地" align="center"
                             show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <div class="margin-top10 margin-bottom10">
          <el-pagination @current-change="handleCurrentChange"
                         :current-page.sync="pageNo" layout="total, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 导入 -->
    <el-dialog title="导入" v-model="visibleImport" width="40%" top="10vh" :destroy-on-close="true">
      <importExcel name='盘点数据导入模板' :downloadUrl="downloadUrl" :requestUrl="requestUrl"></importExcel>
    </el-dialog>
  </div>
</template>

<script>
import importExcel from '../../components/import/importExcel.vue'

export default {
  components: {
    importExcel
  },
  data() {
    return {
      id: '',
      selectHouse: '',
      remark: '',
      searchName: '',
      tableData: [],
      tableDataNew: [],
      visibleImport: false,
      downloadUrl: '', //导入模板下载链接
      requestUrl: '', //导入接口
      houseArray: [], //库房集合
      status: 0, //0 盘点中 1 盘点完成 2 盘点结束
      isDisabledPause: false,//暂存禁用
      isDisabledDone: false,//完成禁用
      isDisabledPing: false,//平库禁用
      pageNo: 1,
      total: 0,
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // html加载完成之前
  created() {
    this.getHouseList()
    let id = this.$route.query.id
    if (id !== '' && id !== undefined && id !== null) {
      this.id = id
      this.getDetail()
    }
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
    },
    houseChange() {
      this.id = ''
      this.tableData = []
      this.tableDataNew = []
      this.pageNo = 1
      this.total = this.tableDataNew.length
    },
    //实际数量输入
    numberInput(item) {
      item.actualNums = this.$method.checkInput(item.actualNums, 0)
      if (Number(item.actualNums) === 0) {
        item.subNums = ''
        item.finishTime = ''
      } else {
        item.subNums = Number(item.actualNums) - Number(item.bookNums)
        //时间节点为空时 联动显示当前时间
        if (this.finishTime === '' || this.finishTime === null || this.finishTime === undefined) {
          item.finishTime = this.getNowDate()
        }
      }
    },
    getNowDate() {
      let date = new Date();
      let year = date.getFullYear()
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hour = date.getHours();
      let minutes = date.getMinutes()
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes
    },
    //取消
    clickCancel() {
      this.$confirm("取消后当前编辑项将无法保存，您确定取消吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.selectHouse = ''
        this.remark = ''
        this.searchName = ''
        this.tableData = []
        this.tableDataNew = []
        this.pageNo = 1
        this.total = this.tableDataNew.length
      }).catch(() => {
      });
    },
    //暂存
    clickPause() {
      this.bus.$emit('loading', 1)
      this.isDisabledPause = true
      if (this.checkFull()) {
        this.saveData(res => {
          this.$message.success('暂存成功')
          this.id = res.data.id
          this.getDetail()
        })
      } else {
        this.isDisabledPause = false
        this.bus.$emit('loading', 0)
      }
    },
    //完成
    clickComplete() {
      if (this.checkFull()) {
        this.isDisabledDone = true
        this.bus.$emit('loading', 1)
        this.saveData(res => {
          this.id = res.data.id
          this.$postFormRequest('/admin/stock/finishStockCheck/' + this.id, {}).then((res) => {
            if (res) {
              this.$message.success('盘点完成成功')
              this.getDetail()
            }
          }).catch((error) => {
            this.isDisabledDone = false
            this.bus.$emit('loading', 0)
            console.log(error)
          })
        })
      }
    },
    //平库
    clickPing() {
      if (this.id === '' || this.id === null) {
        this.$message.error('请先保存')
        return
      }
      this.$confirm("您确定要保存并且平库吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.bus.$emit('loading', 1)
        this.isDisabledPing = true
        this.$postFormRequest('/admin/stock/flatStock', {
          id: this.id
        }).then((res) => {
          if (res) {
            this.bus.$emit('loading', 0)
            this.$message.success('平库成功')
            this.$router.back()
          }
        }).catch((error) => {
          this.isDisabledPing = false
          this.bus.$emit('loading', 0)
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //返回
    clickBack() {
      if (this.selectHouse !== '' && this.selectHouse !== null && this.tableData.length !== 0) {
        this.saveData(res => {
          this.bus.$emit('loading', 0)
          this.$router.back()
        })
      } else {
        this.$router.back()
      }
    },
    //盘点
    clickPan() {
      if (this.status !== 0) {
        return;
      }
      if (this.selectHouse === '' || this.selectHouse === null) {
        this.$message.error('请先选择盘点库房')
        return
      }
      //判断是否在盘点中
      this.check()
    },
    //导入
    clickImport(item) {
      this.downloadUrl = ''
      this.requestUrl = '/admin/stock/importStockCheckDetails'
      this.visibleImport = true
      this.bus.$off('importSuccess')
      this.bus.$on('importSuccess', res => {
        this.visibleImport = false
        if (res === 'refresh') {
          this.getDetail()
        }
      })
    },
    //导出
    clickExport() {
      let token = sessionStorage.getItem('token')
      let url = this.$baseUrl + '/admin/stock/exportCountPhaDetails?id=' + this.id + '&token=' + token
      window.open(url)
    },
    //药品搜索
    drugInput() {
      if (this.selectHouse === '' || this.selectHouse === null) {
        this.$message.error('请先选择盘点库房')
        this.searchName = ''
        return
      }
      if (this.searchName === '' || this.searchName === null) {
        this.tableDataNew = this.tableData
        this.pageNo = 1
        this.total = this.tableDataNew.length
        return
      }
      this.tableDataNew = this.tableData.filter((data) => {
        return data.drugName.indexOf(this.searchName) !== -1
      })
      this.pageNo = 1
      this.total = this.tableDataNew.length
    },
    //检查是否填写完整
    checkFull() {
      if (this.selectHouse === '' || this.selectHouse === null) {
        this.$message.error('请先选择盘点库房')
        return false
      }
      if (this.tableData.length === 0) {
        this.$message.error('无盘点单可保存')
        return false
      }
      return true
    },
    //判断是否在盘点中
    check() {
      this.bus.$emit('loading', 1)
      this.$postFormRequest('/admin/stock/isPding', {
        pharmacyId: this.selectHouse
      }).then((res) => {
        if (res) {
          if (res.data) {
            this.$confirm("此库房包含未完成的盘点单据，不可再次盘点", "温馨提示", {
              confirmButtonText: "知道了",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
            }).catch(() => {
            });
            this.bus.$emit('loading', 0)
          } else {
            this.getData()
          }
        }
      }).catch((error) => {
        this.bus.$emit('loading', 0)
        console.log(error)
      })
    },
    //获取盘点数据
    getData() {
      this.$getRequest('/admin/stock/getStockCheckDrug', {
        pharmacyId: this.selectHouse,
      }).then((res) => {
        if (res) {
          this.tableData = res.data
          this.tableDataNew = res.data
          this.pageNo = 1
          this.total = this.tableDataNew.length
          if (this.tableData.length === 0) {
            this.$message.error('暂无盘点数据')
          }
        }
        this.bus.$emit('loading', 0)
      }).catch((error) => {
        console.log(error)
        this.bus.$emit('loading', 0)
      })
    },
    //获取库房列表
    getHouseList() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //保存盘点数据
    saveData(success) {
      this.bus.$emit('loading', 1)
      let param = {
        pharmacyId: this.selectHouse,
        remark: this.remark,
        details: this.tableData,
      }
      if (this.id !== '') {
        param.id = this.id
      }
      this.$postRequest('/admin/stock/addStockCheck', param).then((res) => {
        if (res) {
          success(res)
        }
      }).catch((error) => {
        this.isDisabledPause = false
        this.bus.$emit('loading', 0)
        console.log(error)
      })
    },
    //获取盘点详情
    getDetail() {
      this.bus.$emit('loading', 1)
      this.$getRequest('/admin/stock/getStockCheckDetail/' + this.id, {}).then((res) => {
        if (res) {
          this.status = res.data.status.value
          this.selectHouse = res.data.pharmacyId
          this.remark = res.data.remark
          this.tableData = res.data.details
          this.tableDataNew = res.data.details
          this.pageNo = 1
          this.total = this.tableDataNew.length
        }
        this.isDisabledPause = false
        this.bus.$emit('loading', 0)
      }).catch((error) => {
        this.isDisabledPause = false
        this.bus.$emit('loading', 0)
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.stockCheck {
  height: 100%;

  .top-div {
    padding: 15px 10px;
    background: #E8EAEB;
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
  }

  .orange-div {
    text-align: center;
    font-size: 15px;
    color: #FFFFFF;
    background-color: darkorange;
    padding: 1px 2px;
    border-radius: 2px;
  }

  .blue-div {
    text-align: center;
    font-size: 15px;
    color: #FFFFFF;
    background-color: dodgerblue;
    padding: 1px 2px;
    border-radius: 2px;
  }

  .green-div {
    text-align: center;
    font-size: 15px;
    color: #FFFFFF;
    background-color: limegreen;
    padding: 1px 2px;
    border-radius: 2px;
  }
}
</style>
